(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('documentField', DocumentField)

    /** @ngInject */
    function DocumentField($rootScope, HelperService, PersonService, UnitService, PATHS) {
        function DocumentFieldController() {
            const vm = this;

            vm.addDocument = () => {
                vm.amountOfDocuments++;
            }

            vm.removeDocument = index => {
                vm.documents.splice(index, 1);

                vm.amountOfDocuments--;
            }

            vm.getNumber = num => {
                let retArray = [];

                for (let i = 0; i < num; i++)
                    retArray.push(i);

                return retArray;
            }

            vm.isTypeDisabled = (type, indexOwner) => {
                return type.disabled && type.indexOwner != indexOwner;
            }

            vm.onChangeType = (selectedType, indexOwner) => {
                if (!selectedType || isNaN(indexOwner)) return;

                vm.documentTypes.forEach(type => {
                    let isTypeSelected = vm.documents.find(document => {
                        if (type.Id == document.DocumentTypeId)
                            return document;
                    })

                    if (isTypeSelected && !type.disabled) {
                        type.disabled = true;
                        type.indexOwner = indexOwner;
                    } else if (!isTypeSelected && !type.disabled) {
                        type.disabled = false;
                        type.indexOwner = null;
                    } else if (!isTypeSelected && type.disabled) {
                        type.disabled = false;
                        type.indexOwner = null;
                    }
                })
            }

            vm.getDocumentTypes = () => {
                HelperService.startLoading('.document-container', true);

                if (vm.type == 1) {
                    return PersonService
                        .getDocumentTypes()
                        .then(success => {
                            vm.documentTypes = success;
                            HelperService.stopLoading('.document-container')
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.document-container')
                        })
                } else {
                    return UnitService
                        .getDocumentTypes()
                        .then(success => {
                            vm.documentTypes = success;
                            HelperService.stopLoading('.document-container')
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.document-container')
                        })
                }
            }

            init();

            function init() {
                vm.documentTypes = [];
                vm.getValidationMessage = $rootScope.ValidationMessage;
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getDocumentTypes()
                .then(() => {
                    ctrl.amountOfDocuments = 1;

                    if (ctrl.documents && ctrl.documents.length) {
                        ctrl.amountOfDocuments = ctrl.documents.length;

                        for (let index = 0; index < ctrl.documents.length; index++) {
                            const document = ctrl.documents[index];
                            let documentType = ctrl.documentTypes.find(type => (type.Id == document.DocumentTypeId));

                            if (documentType) {
                                documentType.disabled = true;
                                documentType.indexOwner = index;
                            }
                        }

                        if (ctrl.amountOfDocuments == 0)
                            ctrl.amountOfDocuments = 1;
                    } else
                        ctrl.documents = [];
                })
        }

        return {
            bindToController: true,
            controller: DocumentFieldController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/document-field/document-field.html`,
            scope: {
                documents: '=',
                type: '=',
                canEdit: '='
            }
        }
    }
}());